import React, { useState } from 'react'
import {
  Box,
  TextField,
  Button,
  Typography,
  Alert,
  CircularProgress
} from '@mui/material'
import { useForm } from 'react-hook-form'
import { rejectUser } from 'api/accounts'

interface RejectUserFormProps {
  accountId: string
}

interface FormData {
  id: string
  reason: string
}

const RejectUserForm = ({ accountId }: RejectUserFormProps) => {
  const [error, setError] = useState('')
  const [successMessage, setSuccessMessage] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const { register, handleSubmit, reset } = useForm<FormData>({
    defaultValues: { id: accountId, reason: '' }
  })

  const onSubmit = async (data: FormData) => {
    setError('')
    setSuccessMessage('')
    setIsLoading(true)

    const result = await rejectUser(data.id, data.reason)
    if (result.success) {
      setSuccessMessage(result.message)
      reset({ id: accountId, reason: '' })
    } else {
      setError(result.message)
    }

    setIsLoading(false)
  }

  return (
    <Box mt={4}>
      <Typography variant='h6'>Reject Account</Typography>

      {error && <Alert severity='error'>{error}</Alert>}
      {successMessage && <Alert severity='success'>{successMessage}</Alert>}

      <Box component='form' onSubmit={handleSubmit(onSubmit)} mt={2}>
        <TextField
          label='Reason for Rejection'
          multiline
          rows={4}
          fullWidth
          margin='normal'
          disabled={isLoading}
          {...register('reason', { required: true })}
        />
        <Button
          type='submit'
          variant='contained'
          fullWidth
          sx={{ mt: 2 }}
          disabled={isLoading}
          startIcon={isLoading ? <CircularProgress size={20} /> : null}
        >
          {isLoading ? 'Rejecting...' : 'Reject'}
        </Button>
      </Box>
    </Box>
  )
}

export default RejectUserForm
